import TokenCollection from './TokenCollection'

import YTCollectionContract from '@/domains/contracts/YTCollectionContract'

export default class YTCollection extends TokenCollection {
  contract({ signer, provider }) {
    return new YTCollectionContract({ ytCollection: this, signer, provider })
  }
}
